
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discussions",
      function () {
        return require("private-next-pages/discussions.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discussions"])
      });
    }
  